// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Collapse_collapse__yqY5R","show":"Collapse_show__7TSKC","hidden":"Collapse_hidden__HRdfP"};